import React, { useState, useRef } from "react";
import axios from "axios";
import * as XLSX from "xlsx";
import style from "./Xlsinvonterytry.module.css"
import { Inventory_api } from '../../../Apiconfig';

const Xlsinvinvonterytry = () => {
  const [tableData, setTableData] = useState([]);
  const [uploadStatus, setUploadStatus] = useState("");
  const fileInputRef = useRef(null); // Reference to the file input
  const [successMessage, setSuccessMessage] = useState("");


  const handleFileUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (event) => {
        const binaryData = event.target.result;
        const workbook = XLSX.read(binaryData, { type: "binary" });
        const sheetName = workbook.SheetNames[0];
        const sheetData = XLSX.utils.sheet_to_json(workbook.Sheets[sheetName]);
        setTableData(sheetData);
      };
      reader.readAsBinaryString(file);
    }
  };

  const uploadToBackend = async () => {
    try {
      console.log("Sending data:", tableData); // Log the data being sent
  
      setUploadStatus("Uploading..."); // Set a loading status
  
      const response = await axios.post(`${Inventory_api}/upload_inventory.php`, tableData, {
        withCredentials: true,
        headers: {
          "Content-Type": "application/json",
        },
      });
  
      console.log("Response from backend:", response.data); // Log the response
  
      if (response.data.status === "success") {
        console.log("Data successfully uploaded");
        setSuccessMessage("Data uploaded successfully!"); // Set the success message
        setTimeout(() => setSuccessMessage(""), 2000); // Clear the success message after 2 seconds
  
        setTableData([]); // Reset the table data
        setUploadStatus(""); // Clear the upload status
      } else {
        console.log("Error:", response.data.message);
        setUploadStatus(`Failed to upload data: ${response.data.message}`); // Show error details
      }
    } catch (error) {
      console.error(error);
      setUploadStatus("Failed to upload data. Please check the console for more details.");
    }
  };
  




  return (
    <>

      <div className="container">
        <div class={`${style.fileUploadSection} mb-3 mt-5`}>
          <div class={`${style.folder}`}>
            <div class={`${style.frontSide}`}>
              <div class={`${style.tip}`}></div>
              <div class={`${style.cover}`}></div>
            </div>
            <div class={`${style.backSide} ${style.cover}`}></div>
          </div>
          <label class={`${style.customFileUpload}`}>
            <input
              ref={fileInputRef} 
              class={`${style.title}`}
              type="file"
              id="fileUpload"
              accept=".xlsx, .xls"
              onChange={handleFileUpload}
            />
            Choose a file
          </label>
        </div>
      </div>

      <div className={`${style.tablerow} row table-responsive m-0`}>
        <table className={style.tablee}>
          <thead>
            <tr>
              <th className={style.addedtablehead}>NAME</th>
              <th className={style.addedtablehead}>NAME 2</th>
              <th className={style.addedtablehead}>NAME 3</th>
              <th className={style.addedtablehead}>HINDI NAME</th>
              <th className={style.addedtablehead}>HINDI NAME 2</th>
              <th className={style.addedtablehead}>HINDI NAME 3</th>
              <th className={style.addedtablehead}>LOCAL NAME</th>
              <th className={style.addedtablehead}>LOCAL NAME 2</th>
              <th className={style.addedtablehead}>LOCAL NAME 3</th>
              <th className={style.addedtablehead}>SKU</th>
              <th className={style.addedtablehead}>MRP</th>
              <th className={style.addedtablehead}>QUANTITY</th>
              <th className={style.addedtablehead}>WEIGHT</th>
              <th className={style.addedtablehead}>UNIT PRICE</th>
              <th className={style.addedtablehead}>SELL PRICE</th>
              <th className={style.addedtablehead}>DISCOUNT</th>
              <th className={style.addedtablehead}>CATEGORY</th>
              <th className={style.addedtablehead}>TYPE 1</th>
              <th className={style.addedtablehead}>TYPE 2</th>
              <th className={style.addedtablehead}>TYPE 3</th>
              <th className={style.addedtablehead}>TYPE 4</th>
              <th className={style.addedtablehead}>CODE</th>
              <th className={style.addedtablehead}>EXPIRY</th>
              <th className={style.addedtablehead}>RACK NO.</th>
              <th className={style.addedtablehead}>WAREHOUSE</th>
              <th className={style.addedtablehead}>BATCH NO.</th>
              <th className={style.addedtablehead}>TRANSPORT</th>

            </tr>
          </thead>
          <tbody className={style.addedtabletbody}>
            {tableData.map((row, index) => (
              <tr key={index}>
                {/* <td className={style.addedtablebody}>{row["ID"]}</td> */}
                <td className={style.addedtablebody}>{row["NAME"]}</td>
                <td className={style.addedtablebody}>{row["NAME 2"]}</td>
                <td className={style.addedtablebody}>{row["NAME 3"]}</td>
                <td className={style.addedtablebody}>{row["HINDI NAME"]}</td>
                <td className={style.addedtablebody}>{row["HINDI NAME 2"]}</td>
                <td className={style.addedtablebody}>{row["HINDI NAME 3"]}</td>
                <td className={style.addedtablebody}>{row["LOCAL NAME"]}</td>
                <td className={style.addedtablebody}>{row["LOCAL NAME 2"]}</td>
                <td className={style.addedtablebody}>{row["LOCAL NAME 3"]}</td>
                <td className={style.addedtablebody}>{row["SKU"]}</td>
                <td className={style.addedtablebody}>{row["MRP"]}</td>
                <td className={style.addedtablebody}>{row["QUANTITY"]}</td>
                <td className={style.addedtablebody}>{row["WEIGHT"]}</td>
                <td className={style.addedtablebody}>{row["UNIT PRICE"]}</td>
                <td className={style.addedtablebody}>{row["SELL PRICE"]}</td>
                <td className={style.addedtablebody}>{row["DISCOUNT"]}</td>
                <td className={style.addedtablebody}>{row["CATEGORY"]}</td>
                <td className={style.addedtablebody}>{row["TYPE 1"]}</td>
                <td className={style.addedtablebody}>{row["TYPE 2"]}</td>
                <td className={style.addedtablebody}>{row["TYPE 3"]}</td>
                <td className={style.addedtablebody}>{row["TYPE 4"]}</td>
                <td className={style.addedtablebody}>{row["CODE"]}</td>
                <td className={style.addedtablebody}>{row["EXPIRY"]}</td>
                <td className={style.addedtablebody}>{row["RACK NO."]}</td>
                <td className={style.addedtablebody}>{row["WAREHOUSE"]}</td>
                <td className={style.addedtablebody}>{row["BATCH NO."]}</td>
                <td className={style.addedtablebody}>{row["TRANSPORT"]}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div className="mt-2">
        <div className={style.savetodatabase}>
          <button onClick={uploadToBackend} className={style.xlsuploadbtn}>
            UPLOAD
          </button>
        </div>
        {uploadStatus && <p>{uploadStatus}</p>}
      </div>
      {/* Success message */}
      {successMessage && (
        <div className={style.successMessage}>
          {successMessage}
        </div>
      )}
      {/* </div> */}
    </>
  );
};

export default Xlsinvinvonterytry;
